<div class="modal__header">
    <h2 class="title" id="modal__title" [innerHTML]="(title$|async)| ibeadmin | async"></h2>
    <div class="modal__header-actions">
        <button [attr.aria-label]="'review.addExtraModal.aria.closeDialog' | ibeadmin | async" (click)="cancel()">
			<app-svg svg="icons.svg#general--close" aria-hidden="true" [alt]="'Close icon'"></app-svg>
		</button>
    </div>
</div>
<div class="modal__body sl--scrollable">

    <!-- do not display text if seat ancillary -->
    <div class="modal__body--content" *ngIf="feature === 'bags'">
        {{'review.addExtraModal.text.moreBaggage' | ibeadmin | async}}
    </div>

    <div class="modal__body--content" *ngIf="feature === 'fasttrack'">
        {{ 'review.rewards.addExtraModal.text.accessToPriorityLane' | ibeadmin | async }}
    </div>

    <div class="modal__body--content" *ngIf="feature === 'prefBoard'">
        {{'review.addExtraModal.text.wantFirstToBoard' | ibeadmin | async}}
    </div>

    <div class="grid no-padding">
        <app-extras-block class="col-6 col-tl-6 col-tp-12 col-p-12" *ngFor="let flightDetail of flightDetails; let listIndex = index" [flightDetail]="flightDetail" [feature]="INDRA_getFeature(flightDetail)" [flight]="flight[listIndex]" [featureName]="(title$|async)| ibeadmin | async">
        </app-extras-block>
    </div>
</div>